export default __webpack_public_path__ + "static/media/mediamanager.bf30c5e9.jpg";